import { Flex, Title } from '@wyz/ui';
import * as React from 'react';
import { Trans, useLocale } from '~/common/context';
import { ValueInfoItem } from '~/purchase/components';
type Props = {
  children: React.ReactNode;
  item: {
    discount?: number;
    unitPrice?: number;
    quantity: number;
    total?: number;
  };
  currency: string;
};
const ExtraServiceItem = ({ item, children, currency }: Props) => {
  const locale = useLocale();

  return (
    <>
      <div>
        <Flex justifyContent='between'>
          <div>{children}</div>
          <Flex className='gap-3' alignItems='end'>
            <ValueInfoItem
              title={
                <Trans i18nKey='app.purchase.cart_page.table.unit_price' />
              }
              align='right'
              id='extra-service-unit-price'
            >
              <Title
                heading='lg'
                weight='semi-bold'
                className='mt-2 text-right'
              >
                <>
                  {locale.formatters.money(item.unitPrice, {
                    currency: currency,
                  })}
                </>
              </Title>
            </ValueInfoItem>
            <ValueInfoItem
              title={<Trans i18nKey='app.common.quantity' />}
              align='right'
              id='extra-service-quantity'
            >
              <Title heading='lg' weight='bold' className='mt-2 text-right'>
                {item.quantity}
              </Title>
            </ValueInfoItem>
            <ValueInfoItem
              title={<Trans i18nKey='app.common.total_price_without_tax' />}
              align='right'
              id='extra-service-total-excl-tax'
            >
              <Title heading='lg' weight='bold' className='mt-2 text-right'>
                {locale.formatters.money(item.total, {
                  currency: currency,
                })}
              </Title>
            </ValueInfoItem>
          </Flex>
        </Flex>
      </div>
    </>
  );
};

export default ExtraServiceItem;
